import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 385.85 459.02" {...props}><g data-name="Layer 2"><g data-name="Capa 1"><path d="M299.36 106.44A106.44 106.44 0 11192.92 0a106.45 106.45 0 01106.44 106.44zM192.92 266.1C86.38 266.1 0 352.48 0 459h385.85c0-106.54-86.38-192.92-192.93-192.92z" /></g></g></svg>);